import { map, set } from 'lodash';
import moment from 'moment';
import { v4 as uuid } from 'uuid';

import { Language } from '@lib/resources/types';
import { getTranslation } from '@lib/services/patientFormsService';
import { updateText } from '@lib/services/stringsService';

import { isMessageTemplateKey } from 'hooks/useMessageTemplate';

import { TMessageWrapper } from '../../../containers/Messages/MessageWrapper';
import { LumaBotAnswers } from '../interfaces';

export const sanitizeLumaBotMessage = (
  partial: Partial<TMessageWrapper>,
  language: Language,
  botName: string,
  answers?: LumaBotAnswers,
): TMessageWrapper => {
  const squigglyReplacements = map(answers, (next, prev) => ({ prev: `{{${prev}}}`, next }));
  let createdBy: any = partial.createdBy;
  if (partial.type !== 'outbound') {
    if (partial.user) {
      createdBy = {
        type: 'staff',
        // TODO: Waiting for product decision:
        // Use staff name (which would require an additional fetch per message),
        // or set a default name/avatar for staff users
        name: 'Staff',
      };
    } else {
      createdBy = {
        type: 'bot',
        name: botName,
      };
    }
  }
  const message = {
    ...partial,
    _id: partial._id || uuid(),
    createdAt: partial.createdAt || moment().format(),
    createdBy,
  };

  const { text: initialText, metadata = {} } = message;
  let text = initialText || '';
  if (message.type === 'inbound' && metadata.item && metadata.item.type === 'template') {
    const textTranslation = updateText(getTranslation(metadata.item, language, 'title') || text, squigglyReplacements);
    const templateTranslation = updateText(
      getTranslation(metadata.item, language, 'properties.template'),
      squigglyReplacements,
    );

    set(message, 'text', textTranslation);
    set(message, 'metadata.item.template', templateTranslation);

    return message as TMessageWrapper;
  }
  if (metadata.item && message.type !== 'outbound' && !isMessageTemplateKey(text)) {
    text = updateText(getTranslation(metadata.item, language, 'title') || text, squigglyReplacements);
  }
  if (metadata.answer) {
    text = updateText(getTranslation(metadata.answer, language, 'label') || text, squigglyReplacements);
  }

  return { ...message, text } as TMessageWrapper;
};
